import { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Hero.css";
import { Link } from "react-router";

export function HeroSection() {
  const [studentsCount, setStudentsCount] = useState(0);
  const [lessonsCount, setLessonsCount] = useState(0);

  const scrollToNextSection = () => {
    window.scrollTo({
      top: window.innerHeight * 2,
      behavior: 'smooth'
    });
  };



  useEffect(() => {
    AOS.init({ duration: 1200 });
    
    // Counter animation
    const animateCounters = () => {
      const studentsTarget = 2000;
      const lessonsTarget = 129;
      const duration = 2000;
      const steps = 60;
      const stepTime = duration / steps;
      
      let currentStep = 0;
      
      const timer = setInterval(() => {
        currentStep++;
        const progress = currentStep / steps;
        
        setStudentsCount(Math.floor(studentsTarget * progress));
        setLessonsCount(Math.floor(lessonsTarget * progress));
        
        if (currentStep >= steps) {
          clearInterval(timer);
          setStudentsCount(studentsTarget);
          setLessonsCount(lessonsTarget);
        }
      }, stepTime);
    };
    
    const counterTimer = setTimeout(animateCounters, 1000);
    
    return () => {
      clearTimeout(counterTimer);
    };
  }, []);



  return (
    <section className="hero-section">
      <div className="container">


        <div className="hero-container">
          {/* Right content */}
          <div 
            className="hero-text" 
            data-aos="fade-up"
          >
            <p className="hero-subtitle">ارفع مستوى تعلمك</p>
            <h1 className="hero-title">
              خلق مستقبل أفضل <br />
              من خلال <span>التعليم</span>
            </h1>
            <p className="hero-desc">
              أكاديميتنا العملية تهدف إلى تزويد المتعلمين بالمهارات العملية والتطبيقية
              التي تؤهلهم لسوق العمل من خلال برامج تدريبية متطورة وتجربة تعليمية تفاعلية.
            </p>
            <div className="hero-buttons">
              <Link to="/about" style={{padding : '15px 30px'}} className="btn-primary text-decoration-none d-block">من نحن</Link>
              <button className="btn-outline">تواصل معنا</button>
            </div>
          </div>

          {/* Left image */}
          <div 
            className="hero-image-wrapper" 
            data-aos="fade-up"
          >
            <div className="image-card">
              <img src="/student.png" alt="طالب" />
              <div className="stat top-right students-stat animated-stat">
                <div className="stat-content">
                  <img src="/studentIcon.png" alt="طلاب" />
                  <h4>{studentsCount.toLocaleString()}</h4>
                  <p>اجمالي الطلاب</p>
                </div>
              </div>
              <div className="stat bottom-left animated-stat">
                <img src="/lesson.png" alt="حصص" />
                <div>
                  <h4>{lessonsCount}+</h4>
                  <p>اجمالي الحصص</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="explore-section" data-aos="fade-up" data-aos-delay="800">
          <div className="explore-text">استكشف</div>
          <div className="explore-arrow" onClick={scrollToNextSection}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7 10L12 15L17 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
        </div>
      </div>
    </section>
  );
}
